/**
 * The earliest quarter to show.
 */
export const MIN_QUARTER = '2011-Q2'
